import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Link } from 'react-router-dom';
import ViewIcon from '@app/assets/icons/view-campaign.svg?react';
import DotsIcon from '@app/assets/icons/menu/dot-vertical.svg?react';
import BinIcon from '@app/assets/icons/bin.svg?react';
import PauseIcon from '@app/assets/icons/pause.svg?react';
import CancelIcon from '@app/assets/icons/cancel.svg?react';
// import PreviewIcon from '@app/assets/icons/preview.svg?react';
import EditIcon from '@app/assets/icons/edit-blue.svg?react';
import { usePermissions } from '@app/contexts/PermissionContext.tsx';
import {AUTOMATION_STATUS_VALUE, AutomationInterface} from "@app/models/automations.ts";
import {includes} from "lodash";

export const AutomationMenu = ({
  deleteAutomation,
  pauseAutomation,
  cancelAutomation,
  continueCreating,
  status,
  automationId,
  disabledActions,
}: {
  deleteAutomation?: () => void;
  pauseAutomation?: () => void;
  cancelAutomation?: () => void;
  continueCreating?: () => void;
  status?: AutomationInterface['status'];
  automationId?: string;
  disabledActions?: {
    deleteAutomation?: boolean;
    cancelAutomation?: boolean;
    pauseAutomation?: boolean;
  };
}) => {
  const isDraft = status === AUTOMATION_STATUS_VALUE.DRAFT;
  const canCancel = !includes([AUTOMATION_STATUS_VALUE.CANCELLED, AUTOMATION_STATUS_VALUE.DRAFT, AUTOMATION_STATUS_VALUE.COMPLETED], status);
  const canDelete = status === AUTOMATION_STATUS_VALUE.DRAFT;
  const canPause = status === AUTOMATION_STATUS_VALUE.ACTIVE;
  const {can} = usePermissions()

  return (
    <Menu>
      <MenuButton 
        className="group/user flex items-center justify-center gap-2 p-2 bg-[#F6F7FA] rounded"
        onClick={(e) => e.stopPropagation()}
      >
        <DotsIcon />
      </MenuButton>
      <MenuItems
        transition
        anchor="left start"
        className="p-2 bg-white shadow-lg mt-2 min-w-[220px] transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 rounded-lg border file:border-base-antiFlash"
      >
        {isDraft ? (
          // Draft campaign options
          <>

            { can('createAutomations') &&
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left"
                onClick={(e) => {
                  e.stopPropagation();
                  continueCreating?.();
                }}
              >
                <EditIcon className="[&_path]:stroke-brand-darkBlue3" /> Continue creating
              </button>
            </MenuItem>
            }
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.deleteAutomation}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteAutomation?.();
                }}
              >
                <BinIcon className="[&_path]:stroke-system-error" /> Delete automation
              </button>
            </MenuItem>
          </>
        ) : (
          // Non-draft campaign options
          <>
            <MenuItem>
              <Link
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full"
                to={`/automations/${automationId}`}
              >
                <ViewIcon className="[&_path]:stroke-brand-darkBlue3" /> Open automation
              </Link>
            </MenuItem>
            {/*<MenuItem>*/}
            {/*  <Link*/}
            {/*    className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full"*/}
            {/*    to={`/`}*/}
            {/*  >*/}
            {/*    <PreviewIcon className="[&_path]:stroke-brand-darkBlue3" /> Open preview*/}
            {/*  </Link>*/}
            {/*</MenuItem>*/}
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.pauseAutomation || !canPause}
                onClick={(e) => {
                  e.stopPropagation();
                  pauseAutomation?.();
                }}
              >
                <PauseIcon className="[&_path]:fill-brand-darkBlue3" />
                Pause automation
              </button>
            </MenuItem>
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.cancelAutomation || !canCancel}
                onClick={(e) => {
                  e.stopPropagation();
                  cancelAutomation?.();
                }}
              >
                <CancelIcon className="[&_path]:stroke-system-error" /> Cancel automation
              </button>
            </MenuItem>
            <MenuItem>
              <button
                className="flex items-center gap-2 p-2 rounded-lg data-[focus]:bg-brand-lightBlue4 text-xs w-full text-left disabled:opacity-40 disabled:cursor-not-allowed"
                disabled={disabledActions?.deleteAutomation || !canDelete}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteAutomation?.();
                }}
              >
                <BinIcon className="[&_path]:stroke-system-error" /> Delete automation
              </button>
            </MenuItem>
          </>
        )}
      </MenuItems>
    </Menu>
  );
};
